import React, { useState } from 'react';
import { Box, Container, Typography, Grid, TextField, Button, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const ContactSection = styled(Box)(({ theme }) => ({
  padding: '80px 0',
  backgroundColor: '#f1f1f1',
}));

const ContactCard = styled(Card)(({ theme }) => ({
  height: '100%',
  padding: '30px',
  borderRadius: '8px',
  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
}));

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      const response = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <ContactSection id="contact">
      <Container>
        <Typography variant="h2" component="h2" align="center" gutterBottom>
          {t('contact.title')}
        </Typography>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <ContactCard>
              <Typography variant="h3" gutterBottom>
                {t('contact.getInTouch')}
              </Typography>
              <Typography paragraph>
                {t('contact.description')}
              </Typography>
              <Box sx={{ mb: 3 }}>
                <a href="mailto:info@gobaadlogistics.com" style={{ color: '#c9a74c', textDecoration: 'none', fontWeight: 500, display: 'block', marginBottom: 4 }}>info@gobaadlogistics.com</a>
                <a href="tel:+2028122236" style={{ color: '#c9a74c', textDecoration: 'none', fontWeight: 500, display: 'block', marginBottom: 4 }}>+202-812-2236</a>
                <span style={{ color: '#c9a74c', fontWeight: 500, display: 'block' }}>Garacad Port, Jarriiban, Mudug, Puntland, Somalia</span>
              </Box>
              <Typography variant="h4" sx={{ mt: 3, mb: 2 }}>
                {t('contact.regionalOffices')}
              </Typography>
              <Typography>
                {t('contact.officesList')}
              </Typography>
            </ContactCard>
          </Grid>
          <Grid item xs={12} md={6}>
            <ContactCard>
              <Typography variant="h3" gutterBottom>
                {t('contact.sendMessage')}
              </Typography>
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label={t('contact.fullName')}
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
                <TextField
                  fullWidth
                  label={t('contact.emailAddress')}
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
                <TextField
                  fullWidth
                  label={t('contact.subject')}
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
                <TextField
                  fullWidth
                  label={t('contact.message')}
                  name="message"
                  multiline
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{ mt: 2 }}
                >
                  {t('contact.sendButton')}
                </Button>
                {status === 'success' && (
                  <Typography color="success.main" sx={{ mt: 2 }}>
                    Message sent successfully!
                  </Typography>
                )}
                {status === 'error' && (
                  <Typography color="error.main" sx={{ mt: 2 }}>
                    Failed to send message. Please try again later.
                  </Typography>
                )}
              </form>
            </ContactCard>
          </Grid>
        </Grid>
      </Container>
    </ContactSection>
  );
};

export default Contact; 